import store from './core/store';
import { tick } from './core/store/phazer.slice';

store.dispatch(tick());
setInterval(() => {
    store.dispatch(tick());
}, 5 * 60 * 1000); // 5min
